module.exports = __webpack_public_path__ + "img/home.133ce3f8.svg";